import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import LiveTicker from "./components/LiveTicker";
import LiveSection from "./components/LiveSection";
import HotTopics from "./components/HotTopics";
import Voices from "./components/Voices";
import Channels from "./components/Channels";
import TrustFaq from "./components/TrustFaq";
import Subscribe from "./components/Subscribe";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <Hero />
        <LiveTicker />
        <LiveSection />
        <HotTopics />
        <Voices />
        <Channels />
        <TrustFaq />
        <Subscribe />
      </main>
      <Footer />
    </div>
  );
}